import DTM from "shared/helpers/DTM";

const EVENTS = {
    SIGN_IN_CLICK: "sign-in-click",
    SIGN_IN_ATTEMPT: "signin-attempt",
    SIGN_IN_SUCCESS: "signin-success",
    SIGN_IN_FAILED: "signin-failed",
    REGISTER_CLICK: "register-click",
    REGISTER_SUCCESS: "register-success",
    REGISTER_FAILED: "register-failed",
    CART_OPEN: "cart-open",
};

const PAGE_NAME = "SignIn page";
const EVARS = {
    SIGN_IN_ATTEMPT: "SignIn Attempted",
    SIGN_IN_SUCCESS: "SignIn Success",
    SIGN_IN_FAILED: "SignIn Failed",
    REGISTER_CLICK: "Register page",
    REGISTER_SUCCESS: "Register Success",
    REGISTER_FAILED: "Register Failed",
};

export const onSignInClick = () => DTM.track(EVENTS.SIGN_IN_CLICK, { pagetype: PAGE_NAME });

export const onSignInAttemptClick = () =>
    DTM.track(EVENTS.SIGN_IN_ATTEMPT, { eVar52: EVARS.SIGN_IN_ATTEMPT });

export const onSignInSuccess = () =>
    DTM.track(EVENTS.SIGN_IN_SUCCESS, { eVar54: EVARS.SIGN_IN_SUCCESS });

export const onSignInFailed = () =>
    DTM.track(EVENTS.SIGN_IN_FAILED, { eVar54: EVARS.SIGN_IN_FAILED });

export const onRegisterClick = () =>
    DTM.track(EVENTS.REGISTER_CLICK, { eVar54: EVARS.REGISTER_CLICK });

export const onRegisterSuccess = (customerId: string) =>
    DTM.track(EVENTS.REGISTER_SUCCESS, { eVar54: EVARS.REGISTER_SUCCESS, customer_id: customerId });

export const onRegisterFailed = () =>
    DTM.track(EVENTS.REGISTER_FAILED, { eVar54: EVARS.REGISTER_FAILED });

export const onCartClick = () => DTM.track(EVENTS.CART_OPEN);
